angular.
module("dx.webapp.library").
directive("dxExamLibrary", function examLibraryDirective() {
	"use strict";

	return {
		restrict: "E",
		scope: {
			exam: "=",
			embedded: "=",
		},
		templateUrl: "tmpl/library/exam-library-directive.html",
		replace: true,
		controller: "DxExamLibraryController",
	};
});
